import React from 'react';

export const Account = ({ height="35px", width="29px",padding="12px",style=''})=> (
    <svg className = "chatLanding-support-XA3-item-grid-image" role="presentation" aria-label="" padding={padding} viewBox="0 0 26 33" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Symbols" stroke="none" strokeWidth="1" fill="rgb(97, 56, 245)" fillRule="evenodd">
            <rect width="24" height="24" fill="none" />
            <g>
                <path d="M16,3.5A1.5,1.5,0,0,1,17.5,5V19A1.5,1.5,0,0,1,16,20.5H8A1.5,1.5,0,0,1,6.5,19V5A1.5,1.5,0,0,1,8,3.5h8M16,2H8A3,3,0,0,0,5,5V19a3,3,0,0,0,3,3h8a3,3,0,0,0,3-3V5a3,3,0,0,0-3-3Z" />
                <path d="M10.19,13.48a3,3,0,0,0,1.91.72c.72,0,1.1-.36,1.1-.78,0-1.18-3.45-.68-3.45-3a1.94,1.94,0,0,1,1.79-1.85V7.5h1.25V8.6a3.66,3.66,0,0,1,1.67.69l-.67,1a2.77,2.77,0,0,0-1.55-.48c-.68,0-1.08.3-1.08.67,0,.92,3.46.61,3.46,2.93a2.11,2.11,0,0,1-1.83,2V16.5H11.54V15.41a4.06,4.06,0,0,1-2.16-1Z" />
            </g>
        </g>
    </svg>
);
